import { Card, CardBody, CardHeader, TabPane } from "reactstrap";
import DataLoop from "./DataLoop";
import ViewBookmark from "../ViewBookmarks";
import { useAppSelector } from "../../../../ReduxToolkit/Hooks";
import { CreatedByMe } from "../../../../Constants/Constants";
import { H5 } from "../../../../AbstractElements";

const DataLoopTab = () => {
  const { gridView } = useAppSelector((state) => state.bookmarkTab);

  return (
    <TabPane tabId="1">
      <Card className="mb-0">
        <CardHeader className="d-flex">
          <H5 className="mb-0">{CreatedByMe}</H5>
          <ViewBookmark />
        </CardHeader>
        <CardBody className="pb-0">
          <div className={`details-bookmark text-center ${!gridView ? "list-bookmark" : ""}`}>
            <DataLoop />
          </div>
        </CardBody>
      </Card>
    </TabPane>
  );
};

export default DataLoopTab;
